<template>
  <div id="engine-nav">
    <button  @click="changeMode('cardsList')" class="btn btn-outline-secondary">Cards</button>
    <button  @click="changeMode('decksList')" class="btn btn-outline-secondary">Decks</button>
    <button @click="changeMode('userSettings')" v-b-tooltip.hover title="User Settings" class="btn btn-outline-secondary ml-4"><i class="fal fa-user-alt"></i></button>
    <button  @click="logout()" v-b-tooltip.hover title="Logout" class="btn btn-outline-warning"><i class="fal fa-sign-out"></i></button>
  </div><!-- /#engine-nav -->
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')

export default {
  computed: {
    ...mapState(['userProfile', 'currentUser'])
  },
  methods: {
    changeMode(mode) {
      this.$emit('changeMode', mode)
    },
    logout() {
      fb.auth.signOut().then(() => {
        this.$store.dispatch('clearData')
        this.$router.push('/')
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/engine/EngineNav.vue